import React, { useState, useEffect, Fragment } from "react";
import { useNavigate } from "react-router-dom";
import Numeral from "react-numeral";
import { Dashboards } from "../../../components/backgrounds/Dashboards";
import { Fifth } from "../../../components/buttons/Fifth";
import { Primary } from "../../../components/buttons/Primary";
import { HttpRequest } from "../../../services/httpRequest";
import { determinarMora2 } from "../../../utils/determinarMora";
import { calcularDeudaAFechaHoy } from "../../../utils/calcularDeudaAFechaHoy";
import { SkeletonDahsboard } from "../../../components/skeleton/skeletonDash";
import { validateSessionAndJwtToken } from "../../../utils/validateTokenSession";
import { returnToSignin } from "../../../utils/returnToSign";
import { DashboardMyCredit } from "../../../components/backgrounds/DashboardMyCredit";

export function CreditDetailPage() {
  const navigate = useNavigate();
  const [basicInfo, setBasicInfo] = useState({});
  const [creditsInfo, setCreditsInfo] = useState([]);
  const [conditions, setConditions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [deudaAFecha, setDeudaAfecha] = useState(0);
  const [creditID, setCreditID] = useState("A000");

  const loadCreditById = async () => {
    try {
      const data = await HttpRequest.getCreditById(
        localStorage.getItem("credit_id")
      );
      return data.message.info;
    } catch (error) {
      console.log(error);
    }
  };

  const loadInfoUser = async () => {
    try {
      const data = await HttpRequest.getInfoUser(localStorage.getItem("doc"));
      return data.message.info;
    } catch (error) {
      console.log(error);
    }
  };

  const configData = (
    creditInfo,
    infoDeudaBackend,
    versionTarifas
  ) => {
    let conditions = [];
    if (versionTarifas === "1") {
      conditions = [
        { title: "Estado del crédito:", value: creditInfo?.status || "" },
        { title: "Valor del crédito:", number: creditInfo?.approvedQuota || "" },
        { title: "Número de cuotas:", value: 1 },
        { title: "Plazo:", value: `${creditInfo?.termInDays || ""} días` },
        { title: "Fecha de aprobación:", value: creditInfo?.approvedDate || "" },
        { title: "Fecha de vencimiento:", value: creditInfo?.paydayLimit || "" },
        { title: "Tasa de interés aplicada:", value: `${localStorage.getItem('currentInterestTea') ?? 25}% E.A` },
        { title: "Tasa de interés moratorio:", value: `Tasa máxima legal permitida` },
        { title: "Días de mora:", value: infoDeudaBackend?.diasMora ?? 0 },
        { title: "Interés corriente:", number: infoDeudaBackend?.intereses ?? 0 },
        { title: "Interés moratorio:", number: infoDeudaBackend?.interesesMoratorios ?? 0 },
        { title: "Administración:", number: 60000 },
        { title: "Gastos de cobranza:", number: infoDeudaBackend?.gastosCobranza ?? 0 },
        { title: "IVA:", number: infoDeudaBackend?.iva ?? 0 },
        { title: "Total a pagar:", number: infoDeudaBackend?.deudaAFecha },
      ];
    } else if (versionTarifas === "2") {
      conditions = [
        { title: "Estado del crédito:", value: creditInfo?.status || "" },
        { title: "Valor del crédito:", number: creditInfo?.approvedQuota || "" },
        { title: "Número de cuotas:", value: 1 },
        { title: "Plazo:", value: `${creditInfo?.termInDays || ""} días` },
        { title: "Fecha de aprobación:", value: creditInfo?.approvedDate || "" },
        { title: "Fecha de vencimiento:", value: creditInfo?.paydayLimit || "" },
        { title: "Tasa de interés aplicada:", value: `${localStorage.getItem('currentInterestTea') ?? 25}% E.A` },
        { title: "Tasa de interés moratorio:", value: `Tasa máxima legal permitida` },
        { title: "Días de mora:", value: infoDeudaBackend?.diasMora ?? 0 },
        { title: "Interés corriente:", number: infoDeudaBackend?.intereses ?? 0 },
        { title: "Interés moratorio:", number: infoDeudaBackend?.interesesMoratorios ?? 0 },
        { title: "Firma electrónica:", number: creditInfo?.firmaElectronica },
        { title: "DCTO firma electrónica:", number: -infoDeudaBackend?.dctoFirmaElectronica ?? 0 },
        { title: "Gastos de cobranza:", number: infoDeudaBackend?.gastosCobranza ?? 0 },
        { title: "IVA:", number: infoDeudaBackend?.iva ?? 0 },
        { title: "Total a pagar:", number: infoDeudaBackend?.deudaAFecha },
      ];
    }
    setConditions(conditions);
    return;
  };

  const loadInfoQuota = async () => {
    try {
      const data = await HttpRequest.getQuotaStatus(localStorage.getItem("doc"));
      return data.message.info;
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const validSessionAndTokenJwt = async () => {
      try {
        let isValidToken = await validateSessionAndJwtToken();
        return isValidToken;
      } catch (error) {
        return false;
      }
    };

    const _loadCreditById = async () => {
      let credit = await loadCreditById();
      return credit;
    };

    const loadInfo = async () => {
      let info = await loadInfoUser();
      return info;
    };

    validSessionAndTokenJwt()
      .then(async (isValidToken) => {
        if (isValidToken) {
          _loadCreditById()
            .then(async (creditData) => {
              let info = await loadInfo();
              let quotaStatus = await loadInfoQuota();
              let versionTarifas = creditData?.versionTarifas;
              let response = versionTarifas === "2" ? await HttpRequest.calcularDeudaV2({ credit: creditData, infoCupo: quotaStatus, }) :
                await HttpRequest.calcularDeuda({ credit: creditData, infoCupo: quotaStatus, });
              let infoDeudaBackend = response?.message?.deuda;
              setBasicInfo(info);
              setCreditID(creditData?.credit_id);
              setIsLoading(false);
              configData(
                creditData,
                infoDeudaBackend,
                versionTarifas
              );
              setDeudaAfecha(deudaAFecha);
              setCreditsInfo(creditData);
            })
            .catch((err) => console.log(err));
        } else {
          returnToSignin(navigate);
        }
      })
      .catch((e) => {
        console.log(e);
        returnToSignin(navigate);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) {
    return (
      <Fragment>
        <DashboardMyCredit
          name={"Cargando"}
          balance={""}
          current={"1"}
          title={`Crédito N.${creditID.substring(0, 8) || ""}`}
          main={
            <>
              <div className="py-10 mb-32 md:mb-0">
                <div className="mx-2 md:mx-8 xl:mx-16 md:px-8 py-5 bg-white shadow-lg rounded-md">
                  <div className="px-4 py-4">
                    <div className="flex justify-between">
                      <span className="font-bold">
                        <SkeletonDahsboard height={20} width={100} />
                      </span>
                      <SkeletonDahsboard height={20} width={50} />
                    </div>
                    <div className="flex justify-between">
                      <span className="font-bold">
                        <SkeletonDahsboard height={20} width={90} />
                      </span>
                      <SkeletonDahsboard height={20} width={80} />
                    </div>
                    <div className="flex justify-between">
                      <span className="font-bold">
                        <SkeletonDahsboard height={20} width={100} />
                      </span>
                      <SkeletonDahsboard height={20} width={10} />
                    </div>
                    <div className="flex justify-between">
                      <span className="font-bold">
                        <SkeletonDahsboard height={20} width={30} />
                      </span>
                      <SkeletonDahsboard height={20} width={50} />
                    </div>
                    <div className="flex justify-between">
                      <span className="font-bold">
                        <SkeletonDahsboard height={20} width={120} />
                      </span>
                      <SkeletonDahsboard height={20} width={90} />
                    </div>
                    <div className="flex justify-between">
                      <span className="font-bold">
                        <SkeletonDahsboard height={20} width={130} />
                      </span>
                      <SkeletonDahsboard height={20} width={90} />
                    </div>
                    <div className="flex justify-between">
                      <span className="font-bold">
                        <SkeletonDahsboard height={20} width={150} />
                      </span>
                      <SkeletonDahsboard height={20} width={50} />
                    </div>
                    <div className="flex justify-between">
                      <span className="font-bold">
                        <SkeletonDahsboard height={20} width={170} />
                      </span>
                      <SkeletonDahsboard height={20} width={80} />
                    </div>
                    <div className="flex justify-between">
                      <span className="font-bold">
                        <SkeletonDahsboard height={20} width={85} />
                      </span>
                      <SkeletonDahsboard height={20} width={10} />
                    </div>
                    <div className="flex justify-between">
                      <span className="font-bold">
                        <SkeletonDahsboard height={20} width={100} />
                      </span>
                      <SkeletonDahsboard height={20} width={30} />
                    </div>
                    <div className="flex justify-between">
                      <span className="font-bold">
                        <SkeletonDahsboard height={20} width={90} />
                      </span>
                      <SkeletonDahsboard height={20} width={50} />
                    </div>
                    <div className="flex justify-between">
                      <span className="font-bold">
                        <SkeletonDahsboard height={20} width={30} />
                      </span>
                      <SkeletonDahsboard height={20} width={40} />
                    </div>
                    <div className="flex justify-between">
                      <span className="font-bold">
                        <SkeletonDahsboard height={20} width={80} />
                      </span>
                      <SkeletonDahsboard height={20} width={60} />
                    </div>

                  </div>
                  <div className="flex px-4 pt-6 justify-center">
                    <a href="/micredito" className="pl-4">
                      <Fifth text={"Volver"} />
                    </a>
                    {creditsInfo[0]?.status === "Cancelado" ? (
                      <div></div>
                    ) : (
                      <a href="/pagar" className="pl-4">
                        <Primary text={"Pagar"} />
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </>
          }
        />
      </Fragment>
    );
  }

  return (
    <DashboardMyCredit
      name={basicInfo.firstname}
      balance={creditsInfo?.status === "Cancelado" ? 0 : deudaAFecha}
      current={"1"}
      title={`Crédito N.${creditID.substring(0, 8) || ""}`}
      main={
        <>
          <div className="py-10 mb-32 md:mb-0">
            <div className="mx-2 md:mx-8 xl:mx-16 md:px-8 py-5 bg-white shadow-lg rounded-md">
              <div className="px-4 py-4">
                {conditions.map((condition) => (
                  <div key={condition.title} className="flex justify-between">
                    <span className="font-bold">
                      {condition.number === 0 ? "" : condition.title}{" "}
                    </span>
                    <span>{condition.value}</span>
                   {/*  {condition.title === 'DCTO firma electrónica:' ? "-": ""} */}<Numeral format={"$0,0"} value={condition.number} />
                  </div>
                ))}
              </div>
              <div className="flex px-4 pt-6 justify-center">
                <a href="/micredito" className="pl-4">
                  <Fifth text={"Volver"} />
                </a>
                {creditsInfo[0]?.status === "Cancelado" ? (
                  <div></div>
                ) : (
                  <a href="/pagar" className="pl-4">
                    <Primary text={"Pagar"} />
                  </a>
                )}
              </div>
            </div>
          </div>
        </>
      }
    />
  );
}
